<ts-dialog [title]="'Generate merge document'" (closeDialog)="matDialogRef.close()">
  <form [formGroup]="form" ts-dialog-body>
    <div class="flex flex-row items-center justify-between field-container">
      <span>Select a document</span>
      <ts-select
        [items]="fileResources$ | async"
        itemKey="id"
        itemLabel="name"
        formControlName="file_id"
        [uiOptions]="{
          roundedBorders: false,
          placeholder: 'Document',
          searchPlaceholder: 'Search for a document...',
          size: 'medium',
        }"
      />
    </div>
  </form>
  <div class="ts-dialog-actions-container" ts-dialog-actions>
    <ts-button variant="secondary" (click)="matDialogRef.close()">Cancel</ts-button>
    @if (canShowDocusignButton$ | async) {
      <ts-button variant="primary" (click)="save()" [disabled]="!form.get('file_id')?.value"
        >Send to Docusign</ts-button
      >
    }
    <ts-button variant="primary" (click)="save('docusign')" [disabled]="!form.get('file_id')?.value">Save</ts-button>
  </div>
</ts-dialog>
